// extracted by mini-css-extract-plugin
export var dateLabel = "_2n-0";
export var dateLabelError = "_2n-1";
export var fullWidth = "_2n-2";
export var smaller = "_2n-3";